<template lang="pug">
div
  b-row
    b-col.order-md-2(md="4")
      b-card
        b-button(variant="primary", block, @click="new_response_modal=!new_response_modal") Crear respuesta
        hr
        .text-help
          alert-circle-icon.icon-md.mr-2
          span Son templates de respuesta y estarán disponibles para todos los admins en la vista de caso y conversación.
    b-col(md="8")
      b-row.align-items-center.mb-3
        b-col.d-flex.align-items-center
          b-input-group
            b-form-input(placeholder="Buscar respuesta...", v-model="response_search", type="search")
            b-input-group-append
              b-input-group-text
                search-icon.text-secondary.icon-sm
      b-card(no-body, style="width:100%;")
        b-table.card-table.mb-0(:items="response_templates", :fields="fields", responsive, show-empty, hover, @row-clicked="prevUpdate($event)")
          template(v-slot:empty)
            p.text-help.mb-0 No hay respuestas creadas
          template(v-slot:cell(text)="{ item }")
            b-overlay(:show="loading == item.response_template_id", variant="transparent", spinner-variant="primary")
              .d-flex.align-items-start
                b-img.mr-3(:src="item.image", v-if="item.image", width="50", height="50", rounded)
                .d-flex.flex-column
                  b-link.text-dark(@click="prevUpdate(item)") {{ item.name }}
                  p.mb-0.text-secondary {{ item.text }}
                  div.text-help.mt-2.pl-2.bl-2(v-if="item.file")
                    file-icon.file-icon.icon-sm.mr-1.mb-1
                    b-link.text-reset(:href="item.file", target="blank") {{ getFileName(item.file) }}
      b-pagination(v-model="pagination_page", align="center", v-if="pagination_hasNextPage", :total-rows="100", :per-page="pagination_limit", :limit="3" @change="pageChange")

  b-modal(v-model="new_response_modal", centered, title="Crear nueva respuesta automática", cancel-title="Cancelar", ok-title="Crear respuesta", ok-variant="success", @ok="createResponse", @show="resetModal")
    b-container(fluid)
      label Nombre:
      b-form-input.mb-2(v-model="new_response.name" placeholder="Nombre", trim, :state="new_response.name ? null : (new_response.validated ? false : null)")
      label Descripción:
      b-form-input.mb-2(v-model="new_response.description" placeholder="Descripción", trim)
      label Mensaje:
      b-form-textarea.mb-2(v-model="new_response.text" placeholder="Mensaje", trim, :state="new_response.text ? null : (new_response.validated ? false : null)", max-rows="5")
      label Categoría:
      b-form-input(v-model="new_response.category" placeholder="Categoría", trim)
      p.my-2 Imagen:
        span.ml-2.text-danger.text-sm.text-underline.pointer(v-if="new_response.image", @click="new_response.image = ''") Quitar imagen
      .image-wrapper.pointer(v-b-tooltip.hover :title="new_response.image ? 'Cambiar imagen' : 'Subir imagen'", @click="$refs.input_image.click()")
        b-img(:src="new_response.image", :blank="!new_response.image", blank-color="#d2d2d2", rounded, width="80", height="80")
        image-icon.file-icon.icon-md.text-light
      p.my-2 Archivo:
        span.ml-2.text-danger.text-sm.text-underline.pointer(v-if="new_response.file", @click="new_response.file = ''") Quitar archivo
      .image-wrapper.pointer(v-b-tooltip.hover :title="new_response.file ? 'Cambiar archivo' : 'Subir archivo'", @click="$refs.input_file.click()")
        b-img(:blank="true", blank-color="#d2d2d2", rounded, width="80", height="80")
        file-icon.file-icon.icon-md.text-light
      span.text-secondary(v-if="new_response.file") {{new_response.file_name}}

  b-modal(v-model="update_response_modal", centered, title="Actualizar respuesta", cancel-title="Cancelar", ok-title="Guardar", ok-variant="primary", @ok="updateResponse")
    b-container.overflow-md-y.scrollable-area(fluid style="max-height: calc(90vh - 200px);")
      label Nombre:
      b-form-input.mb-2(v-model="update_response.name" placeholder="Nombre", trim, :state="update_response.name ? null : (update_response.validated ? false : null)")
      label Descripción:
      b-form-input.mb-2(v-model="update_response.description" placeholder="Descripción", trim)
      label Mensaje:
      b-form-textarea.mb-2(v-model="update_response.text" placeholder="Mensaje", trim, :state="update_response.text ? null : (update_response.validated ? false : null)", max-rows="5")
      label Categoría:
      b-form-input(v-model="update_response.category" placeholder="Categoría", trim)
      b-card.card-inactive.mt-2
        b-row.pointer(v-b-toggle="'groups_' + update_response.response_template_id" @click="update_response.groupsOpen=!update_response.groupsOpen")
          b-col.d-flex.align-items-center
            h5.mb-0 Grupos asociados
          b-col(cols="auto")
            plus-icon.icon-md.hover-primary.mr-3.text-secondary(v-b-tooltip.hover="'Agregar grupo'" @click.stop="addGroupModal.show=true")
            chevron-down-icon.collapse-icon(v-if=" update_response.groupsOpen ")
            chevron-up-icon.collapse-icon(v-else)
        b-collapse.mt-3(:id="'groups_' + update_response.response_template_id")
          b-container.d-flex.justify-content-start.align-items-start.flex-wrap
            b-badge.mr-2.pointer.group-badge(variant="info" pill v-for="group in update_response.Groups", :key="group.group_id" @click="updateTagGroup(group.group_id,'remove')" @mouseover="hoverEffect" @mouseleave="leaveEffect" v-b-tooltip="'Eliminar grupo'") {{group.name}}
      b-container.d-flex.justify-content-center.align-items-baseline
        b-col
          p.my-2 Imagen
            trash-2-icon.icon-sm.ml-2.pointer.hover-danger(v-if="update_response.image", @click="update_response.image = ''")
          .image-wrapper.pointer(v-b-tooltip.hover :title="update_response.image ? 'Cambiar imagen 1' : 'Subir imagen'", @click="$refs.input_image_update.click()")
            b-img(:src="update_response.image", :blank="!update_response.image", blank-color="#d2d2d2", rounded, width="80", height="80")
            image-icon.file-icon.icon-md.text-light
        b-col(cols="6")
          p.my-2(v-b-tooltip="getFileName(update_response.file)") Archivo
            trash-2-icon.icon-sm.ml-2.pointer.hover-danger(v-if="update_response.file", @click="update_response.file = ''")
          .image-wrapper.pointer(v-b-tooltip.hover :title="update_response.file ? 'Cambiar archivo' : 'Subir archivo'", @click="$refs.input_file_update.click()")
            b-img(:blank="true", blank-color="#d2d2d2", rounded, width="80", height="80")
            //- download-icon.file-icon.icon-md.text-light
            //- div.text-help.mt-2(v-if="update_response.file")
            //-   arrow-down-circle-icon.icon-sm.mr-1.mb-1
            //-   b-link.text-reset(:href="typeof update_response.file == 'object' ? '#' : update_response.file", target="blank") {{ getFileName(update_response.file) }}
      b-card.bg-light.text-center.text-sm.mb-0.mt-4
        alert-triangle-icon.icon-sm.mr-2
        span Eliminar respuesta no se puede deshacer.
        p.mb-0.mt-2
          b-link.text-danger(@click="deleteResponse(update_response)") Eliminar respuesta
  b-modal(v-model="addGroupModal.show", centered, :title="addGroupModal.title", cancel-title="Cancelar", :ok-title="addGroupModal.ok_title", :ok-variant="addGroupModal.ok_variant" @ok="updateTagGroup(addGroupModal.group_id)" :ok-disabled="(filterGroups(update_response||{})||[]).length == 0")
    b-container
      b-form-group(label="Nombre del grupo")
        b-select(v-model="addGroupModal.group_id")
          option(:value="null" disabled) Seleccionar grupo...
          option(v-for="group in filterGroups(update_response||{})", :key="group.group_id", :value="group.group_id") {{group.name}}
  input(type="file", accept="image/*", style="display:none;", ref="input_image", @change="imageSelected($event)")
  input(type="file", accept="image/*", style="display:none;", ref="input_image_update", @change="imageSelected($event, 'update')")
  input(type="file", :accept="permitted_files", style="display:none;", ref="input_file", @change="fileSelected($event)")
  input(type="file", :accept="permitted_files", style="display:none;", ref="input_file_update", @change="fileSelected($event, 'update')")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import { UploadFile } from '../../helpers/upload-file'
import debounce from 'lodash.debounce'
const responseTemplateController = createNamespacedHelpers('response_template')
const helpersController = createNamespacedHelpers('helpers')
const groupController = createNamespacedHelpers('group')

export default {
  data () {
    return {
      loading: false,
      response_templates: [],
      fields: [
        {
          key: 'text',
          label: 'Nombre y contenido'
        }
      ],
      new_response_modal: false,
      new_response: {
        name: '',
        description: '',
        text: '',
        category: '',
        image: '',
        file_image: '',
        file: '',
        file_name: '',
        new_file: false,
        validated: false
      },
      update_response_modal: false,
      update_response: {
        name: '',
        description: '',
        text: '',
        category: '',
        image: '',
        file_image: '',
        file: '',
        file_name: '',
        file_type: '',
        new_file: false,
        validated: false,
        Groups: [],
        groupsOpen: false
      },
      addGroupModal: {
        show: false,
        title: 'Agregar grupo',
        ok_title: 'Agregar',
        ok_variant: 'success',
        group_id: null
      },
      groups: [],
      permitted_files: '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv',
      file_types: [
        { type: 'file', title: 'Documento' },
        { type: 'video', title: 'Video' },
        { type: 'audio', title: 'Audio' }
      ],
      response_search: ''
    }
  },
  methods: {
    ...mapActions(['response_template/all', 'response_template/search', 'response_template/create', 'response_template/update', 'response_template/destroy', 'helpers/upload_file', 'response_template/responseGroup', 'group/all']),
    getResponses () {
      this['response_template/all']({
        account_id: this.$route.params.account_id,
        params: {
          ...this.paginationParams
        },
        callback: res => {
          this.hideLoadingScreen()
          if (res.error) return this.$message.error(res.error)
          this.response_templates = res.resource.map(res => ({ ...res, groupsOpen: false }))
        }
      })
    },
    searchResponse: debounce(function () {
      if (!this.response_search.length) return
      const self = this
      // this.showLoadingScreen()

      this['response_template/search']({
        params: {
          ...self.paginationParams,
          account_id: self.$route.params.account_id,
          search: self.response_search
        },
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.response_templates = res.resource
            self.parseResponseForPaginationData(res)
          }
        }
      })
    }, 800),
    async createResponse (bvModalEvt) {
      if (!this.new_response.name || !this.new_response.text) {
        bvModalEvt.preventDefault()
        this.new_response.validated = true
        return
      }

      if (this.new_response.file_image) {
        try {
          const res = await UploadFile.call(this, this.new_response.file_image)
          this.new_response.image = res
        } catch (e) {
          this.$message.error(e.message)
        }
      }

      if (this.new_response.new_file) {
        try {
          const res = await UploadFile.call(this, this.new_response.file)
          this.new_response.file = res
          this.new_response.file_type = 'file'
        } catch (e) {
          this.$message.error(e.message)
        }
      }

      const self = this
      this['response_template/create']({
        account_id: self.$route.params.account_id,
        ...self.new_response,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.getResponses()
          }
        }
      })
    },
    prevUpdate (response) {
      console.log('PREV ', this.update_response)
      console.log('response', response)
      this.$refs.input_image_update.value = ''
      this.$refs.input_file_update.value = ''
      this.update_response = { ...this.update_response, ...response }
      this.update_response_modal = true
      console.log('PREV 2 ', this.update_response)
    },
    async updateResponse (bvModalEvt) {
      this.loading = this.update_response.response_template_id
      //console.log('UPDATE RESPONSE', this.update_response)
      if (!this.update_response.name || !this.update_response.text) {
        //console.log('PREV')
        this.update_response.validated = true
        bvModalEvt.preventDefault()
        return
      }

      //console.log('FILE', this.update_response.file_image)
      if (this.update_response.file_image) {
        try {
          const res = await UploadFile.call(this, this.update_response.file_image)
          //console.log('RES', res)
          this.update_response.image = res
        } catch (e) {
          this.$message.error(e.message)
        }
      }

      if (this.update_response.new_file) {
        try {
          const res = await UploadFile.call(this, this.update_response.file)
          this.update_response.file = res
          this.update_response.file_type = 'file'
        } catch (e) {
          this.$message.error(e.message)
        }
      }
      this.update_response.file_type = 'file'

      console.log('UPDATE !!', this.update_response)
      this['response_template/update']({
        ...this.update_response,
        callback: res => {
          if (res.error) {
            this.$message.error(res.error)
          } else {
            this.getResponses()
            this.resetUpdateModal()
          }
          this.loading = false
        }
      })
    },
    async deleteResponse (response_template) {
      const self = this
      try {
        const response = await this.$bvModal.msgBoxConfirm('¿Deseas eliminar esta respuesta? No se podrá recuperar.', {
          title: 'Eliminar respuesta automática',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar'
        })
        if (response) {
          this['response_template/destroy']({
            ...response_template,
            callback: res => {
              if (res.error) {
                self.$message.error(res.error)
              } else {
                self.getResponses()
                self.update_response_modal = false
              }
            }
          })
        }
      } catch (e) {
        console.error(e.message)
      }
    },
    resetModal () {
      this.clearObject(this.new_response)
      this.new_response.file_image = null
      this.$refs.input_image_update.value = ''
      this.$refs.input_file.value = ''
    },
    resetUpdateModal () {
      console.log('RESET UPDATE')
      this.clearObject(this.update_response)
      console.log(this.update_response)
      this.update_response.file_image = null
      this.$refs.input_image_update.value = ''
      this.$refs.input_file_update.value = ''
    },
    async imageSelected (event, type) {
      const files = event.target.files
      console.log('IMAGE SELECTED', this.update_response)

      if (files.length) {
        const file = files[0]
        try {
          if (type == 'update') {
            this.update_response.image = URL.createObjectURL(file)
            this.update_response.file_image = file
            console.log('IMAGE SELECTED 2', this.update_response)
          } else {
            this.new_response.image = URL.createObjectURL(file)
            this.new_response.file_image = file
          }
        } catch (e) {
          this.$message.error('Error creando vista previa de la imagen')
        }
      }
    },
    async fileSelected (event, type) {
      const files = event.target.files

      if (files.length) {
        const file = files[0]
        try {
          if (type == 'update') {
            this.update_response.file = file
            this.update_response.file_name = file.name
            this.update_response.new_file = true
          } else {
            this.new_response.file = file
            this.new_response.file_name = file.name
            this.new_response.new_file = true
          }
        } catch (e) {
          this.$message.error('Error con el archivo seleccionado')
        }
      }
    },
    getFileType (response_file) {
      const file_type = this.file_types.find(f => f.type == response_file)
      if (file_type) return file_type.title
      else return 'Documento'
    },
    getFileName (file) {
      if (!file) return ''
      if (typeof file === 'object') {
        return file.name
      } else {
        try {
          return file.match(/\.com\/.+\.\w{3,4}/gmi)[0].split('/').slice(-1).join('').slice(13)
        } catch (e) {
          console.log(e.message)
          return file
        }
      }
    },
    pageChange(page) {
      /* if(this.response_search){
        this.searchResponse()
      } else {
        this.getResponses()
      } */
    },
    filterGroups({ Groups = [] } = { Groups: [] }) {
      return this.groups.filter(
        (g) => !Groups.find((cg) => cg.group_id == g.group_id)
      )
    },
    getGroups() {
      this['group/all']({
        account_id: this.$route.params.account_id,
        callback: (res) => {
          if (res.error) return this.$message.error(res.error)
          this.groups = res.resource
        }
      })
    },
    updateTagGroup(groupId, mode = 'add') {
      const body = {
        mode,
        groups: [groupId]
      }
      const { response_template_id: resId } = this.update_response
      this['response_template/responseGroup']({
        responseGroup: resId,
        body,
        callback: (res) => {
          if (res.error) return this.$message.error(res.error)
          const responseTemp = this.response_templates.find(
            (rt) => rt.response_template_id == resId
          )
          responseTemp.Groups = res.Groups
          this.update_response.Groups = res.Groups
          if (mode === 'remove') return this.$message.success('Grupo eliminado')
          this.$message.success('Grupo agregado')
          this.addGroupModal.group_id = null
        }
      })
    },
    hoverEffect(e) {
      e.preventDefault()
      const el = e.target
      el.classList.add('badge-danger')
      el.classList.remove('badge-primary')
    },
    leaveEffect(e) {
      e.preventDefault()
      const el = e.target
      el.classList.add('badge-primary')
      el.classList.remove('badge-danger')
    }
  },
  mounted () {
    this.getResponses()
    this.getGroups()
  },
  watch: {
    response_search (val) {
      this.resetPagination()
      if (val) {
        this.searchResponse()
      } else {
        this.getResponses()
      }
    }
  },
  computed: {
    response_rows () {
      return this.response_templates.length
    }
  }
}
</script>

<style lang="scss" scoped>
  .image-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;

    &:not(:last-child) {
      margin-right: 0.5rem;
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }

    .file-icon {
      z-index: 1;
    }

    .remove-file {
      position: absolute;
      top: -5px;
      right: -5px;
      width: 20px;
      height: 20px;
      background-color: #e63757;
      border-radius: 50%;
      display: none;
      align-items: center;
      justify-content: center;

      .icon-sm {
        position: relative;
        top: -0.03px;
        left: 0.05px;
      }
    }

    &:hover {
      .remove-file {
        display: flex;
      }
    }
  }
  .float-btn {
    position: fixed;
    top: 80%;
    right: 40%;
    z-index: 1080;
  }
</style>
